import winston from 'apps/new-web/lib/winston';

// TODO: Integrate with /apps/new-web/views/onboarding/activate/analytics-helper.js

const events = {
  SIGNED_IN: 'Signed In'
};

const format = args => Object.keys(args).map(arg => `${arg}=${args[arg]}`).join(' ');

function track(event, userId, properties) {
  try {
    if (!lib.enabled) return;
    return lib.client.track({ event, properties, userId });
  } catch (err) {
    winston.info('Segment track error. ' + format({ event, userId, ...properties, error: err.message }));
  }
}

function identify(user) {
  try {
    if (!lib.enabled) return;

    const {
      _id: userId,
      login: { ifit: { email } },
      personal: {
        firstname,
        lastname
      }
    } = user;

    const traits = {
      firstname,
      lastname,
      email,
      timestamp: new Date()
    };

    return lib.client.identify(userId, traits);
  } catch (err) {
    winston.info('Segment identify error. ' + format({ user: user ? user._id : undefined, error: err.message }));
  }
}

function trackSignedIn({ email, userId }) {
  return lib.track(events.SIGNED_IN, userId, { email, timestamp: new Date() });
}

const lib = {
  get client() { return window.analytics; },
  get enabled() { return Boolean(lib.client); },
  identify,
  track,
  trackSignedIn
};

export default lib;